import { useNotification } from '@/hooks';
import { useCreateAssetModelMutation, useUpdateAssetModelMutation } from '../service';
import { AssetModelSchema } from '../models';
import { NotificationSeverity } from '@/components/notifications/Notification';

const useAssetModelsActions = () => {
  const [createAssetModel, { isLoading: isCreatingAssetModel }] = useCreateAssetModelMutation();
  const [updateAssetModel, { isLoading: isUpdatingAssetModel }] = useUpdateAssetModelMutation();

  const { showNotification } = useNotification();

  const onCreateAssetModel = async (data: AssetModelSchema, reset: () => void) => {
    try {
      const result = await createAssetModel({ name: data.name, brandId: data.brandId }).unwrap();
      showNotification(
        'Modelo creado correctamente',
        NotificationSeverity.success
      );
      reset();
      return result;
    } catch (error: any) {
      console.error('Error creating asset model:', error);
      showNotification(
        'Ocurrió un error al crear el modelo. Inténtalo nuevamente.',
        NotificationSeverity.error
      );
      throw error;
    }
  };

  const onUpdateAssetModel = async (
    assetModelId: string,
    data: AssetModelSchema,
    reset: () => void
  ) => {
    try {
      await updateAssetModel({ assetModelId, body: { name: data.name, brandId: data.brandId } }).unwrap();
      showNotification(
        'Modelo actualizado correctamente',
        NotificationSeverity.success
      );
      reset();
    } catch (error: any) {
      console.error('Error updating asset model:', error);
      showNotification(
        'Ocurrió un error al actualizar el modelo. Inténtalo nuevamente.',
        NotificationSeverity.error
      );
    }
  };

  return {
    isCreatingAssetModel,
    isUpdatingAssetModel,
    onCreateAssetModel,
    onUpdateAssetModel,
  };
};

export default useAssetModelsActions; 